import { Ban, ServerCrash, TriangleAlert } from "lucide-react"; // Import relevant icons

export function ErrorComponent({ error, title = "Une erreur est survenue" }) {
  let icon = <TriangleAlert className="w-16 h-16 text-warning animate-pulse" />; // animate-pulse is common
  let errorMessage =
    "Désolé, quelque chose d'inattendu s'est produit. Veuillez réessayer plus tard.";
  const errorDetail = error?.message || String(error);

  // Customize based on known error types or messages
  if (error instanceof Response) {
    if (error.status === 403) {
      icon = <Ban className="w-16 h-16 text-error animate-bounce" />; // animate-bounce is common
      title = "Accès non autorisé";
      errorMessage = "Vous n'avez pas les permissions nécessaires pour accéder à cette ressource.";
    } else if (error.status === 404) {
      icon = <TriangleAlert className="w-16 h-16 text-warning animate-spin" />; // Using animate-spin
      title = "Page introuvable";
      errorMessage = "La page que vous recherchez n'existe pas.";
    } else if (error.status >= 500) {
      icon = <ServerCrash className="w-16 h-16 text-error animate-pulse" />; // Using animate-pulse for server errors
      title = "Erreur serveur";
      errorMessage = "Un problème est survenu sur nos serveurs. Nous travaillons à le résoudre.";
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 p-6">
      <div className="card w-full max-w-lg shadow-xl bg-base-100 text-center p-8 space-y-6">
        <figure className="flex justify-center mb-4">{icon}</figure>
        <div className="card-body p-0">
          <h2 className="card-title justify-center text-3xl font-extrabold text-base-content mb-2">
            {title}
          </h2>
          <p className="text-lg text-base-content opacity-80 mb-4">{errorMessage}</p>
          {import.meta.env.DEV && (
            <div className="collapse bg-base-200 mt-4">
              <input type="checkbox" className="peer" />
              <div className="collapse-title text-xl font-medium peer-checked:text-primary">
                Détails techniques (développement)
              </div>
              <div className="collapse-content overflow-x-auto">
                <pre className="text-sm text-error bg-error-content p-4 rounded-lg text-left whitespace-pre-wrap break-all">
                  {errorDetail}
                </pre>
              </div>
            </div>
          )}
          <div className="card-actions justify-center mt-6">
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
              Recharger la page
            </button>
            <button className="btn btn-ghost" onClick={() => window.history.back()}>
              Retour
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
